// Analytics consent state (GDPR / ePrivacy opt-in). The banner decision is
// kept client-side so it survives reloads, and is re-asked after 12 months
// or whenever CONSENT_VERSION is bumped (e.g. on a material policy change).
//
// The storage semantics (key, version, shape, expiry) live in consent-core.mjs,
// which the static blog inlines into its own runtime — keep them there so the
// two surfaces cannot drift. This module only adds the React-side pub-sub.
import { readConsent, writeConsent } from './consent-core.mjs';

const listeners = new Set();

export const getConsent = readConsent;

export const setConsent = (analytics) => {
  writeConsent(analytics);
  listeners.forEach((fn) => fn(getConsent()));
};

// Keeps the banner and the privacy-page cookie widget in sync.
export const subscribeConsent = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
